<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <situacion-laboral-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import SituacionLaboralShowData from "./SituacionLaboralShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "SituacionLaboralShow",
        components: {CrudShow, SituacionLaboralShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.situacionLaboral.showing',
            }
        },
    }
</script>

